var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModificationIconSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3529_100949)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#BA0C2F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3529_100949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0051 34.6065C19.0051 30.221 19.002 25.8369 19.0051 21.4514C19.0083 18.7408 20.7704 17.0092 23.532 17.0077C27.8129 17.0046 32.0938 17.0199 36.3731 17.0001C37.8084 16.9939 38.9946 17.4635 39.98 18.493C40.7272 19.2716 41.518 20.0104 42.2979 20.7569C43.2786 21.6961 43.7674 22.8189 43.7534 24.1757C43.7316 26.4442 43.7487 28.7127 43.7472 30.9828C43.7472 32.1744 43.2739 32.7878 42.3539 32.8046C41.4215 32.8214 40.9373 32.2187 40.9358 31.0256C40.9342 28.7571 40.9716 26.4871 40.9062 24.2201C40.8922 23.7168 40.6276 23.134 40.2913 22.7455C39.555 21.8935 38.7377 21.0965 37.8722 20.3699C37.4939 20.0517 36.9211 19.7963 36.4338 19.7917C32.128 19.7473 27.8207 19.7642 23.5149 19.7672C22.3287 19.7672 21.8087 20.2781 21.8087 21.4468C21.8056 30.2164 21.8056 38.986 21.8087 47.7556C21.8087 48.9242 22.3287 49.4351 23.5133 49.4397C25.2257 49.4458 26.938 49.4382 28.6504 49.4428C29.7043 49.4458 30.3519 49.969 30.3612 50.8072C30.3705 51.647 29.7167 52.1931 28.6769 52.1962C26.9131 52.2008 25.1478 52.2038 23.3841 52.1962C20.8234 52.1855 19.0114 50.4218 19.0051 47.9162C18.9958 43.4801 19.002 39.0441 19.002 34.6081L19.0051 34.6065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9287 30.7563C52.5321 30.8374 53.8661 31.5885 54.5884 33.1962C55.3216 34.8283 55.0835 36.4115 53.8303 37.6643C49.9402 41.5527 46.0235 45.4197 42.0088 49.1842C41.0468 50.0868 39.6691 50.5655 38.4736 51.2218C37.9755 51.494 37.4649 51.748 36.9403 51.9667C35.8381 52.4256 34.599 52.1579 33.802 51.3181C32.9723 50.4447 32.7886 49.2929 33.3505 48.2022C34.0292 46.8836 34.7282 45.5758 35.4458 44.2771C35.6404 43.9237 35.8973 43.5872 36.1853 43.3027C39.9992 39.5535 43.8271 35.8195 47.6425 32.0734C48.5142 31.2168 49.5448 30.7747 50.9271 30.7579L50.9287 30.7563ZM35.9907 49.169C36.0529 49.2378 36.1168 49.3082 36.179 49.377C37.5972 48.554 39.2146 47.9406 40.3961 46.8653C43.6652 43.8916 46.7536 40.7267 49.9122 37.6353C50.5364 37.0249 51.1793 36.4299 51.7693 35.7874C52.3188 35.1893 52.2877 34.4673 51.7646 33.9304C51.2431 33.3981 50.4227 33.3705 49.7985 33.8769C49.5993 34.039 49.4202 34.2241 49.2365 34.4046C45.9504 37.6215 42.7234 40.8996 39.3531 44.0308C37.7622 45.5085 37.0492 47.4205 35.9907 49.1674V49.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3301 35.0775C29.6474 35.0775 27.963 35.0821 26.2802 35.076C25.2777 35.0714 24.6379 34.5513 24.6177 33.7483C24.5959 32.9253 25.2762 32.3287 26.2818 32.3272C29.6738 32.3211 33.0674 32.3196 36.4594 32.3272C37.4666 32.3287 38.1453 32.9253 38.122 33.7498C38.1002 34.5529 37.4635 35.0714 36.4579 35.076C34.7486 35.0837 33.0394 35.0775 31.3301 35.0775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3655 29.5784C29.6827 29.5784 27.9984 29.583 26.3156 29.5769C25.2648 29.5738 24.6095 29.0369 24.6173 28.2094C24.625 27.3849 25.296 26.8296 26.3234 26.8281C29.6905 26.822 33.0576 26.822 36.4232 26.8281C37.4475 26.8296 38.12 27.3925 38.1215 28.2155C38.1231 29.0461 37.474 29.5723 36.4154 29.5754C34.7326 29.5815 33.0483 29.5769 31.3655 29.5769V29.5784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5454 40.5767C27.7422 40.5767 26.9374 40.5904 26.1341 40.5736C25.253 40.5553 24.6412 40.0076 24.6179 39.252C24.593 38.4795 25.2374 37.8416 26.1232 37.8309C27.7562 37.811 29.3907 37.8095 31.0237 37.8309C31.8798 37.8432 32.4932 38.4443 32.4994 39.2015C32.5056 39.9663 31.9063 40.5476 31.0346 40.5706C30.2048 40.5935 29.3751 40.5751 28.5454 40.5751V40.5767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3501 44.7864C27.5468 44.7864 26.742 44.8002 25.9388 44.7833C25.0577 44.765 24.4459 44.2174 24.4226 43.4617C24.3977 42.6892 25.0421 42.0513 25.9279 42.0406C27.5609 42.0208 29.1954 42.0192 30.8284 42.0406C31.6845 42.0529 32.2979 42.654 32.3041 43.4112C32.3103 44.1761 31.711 44.7573 30.8392 44.7803C30.0095 44.8032 29.1798 44.7849 28.3501 44.7849V44.7864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8235 55C32.74 55 33.4829 54.27 33.4829 53.3694C33.4829 52.4688 32.74 51.7388 31.8235 51.7388C30.907 51.7388 30.1641 52.4688 30.1641 53.3694C30.1641 54.27 30.907 55 31.8235 55Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3529_100949",
    x: -10,
    y: -10,
    width: 91,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3529_100949"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3529_100949",
    result: "effect2_innerShadow_3529_100949"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3529_100949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 38,
    fill: "white",
    transform: "translate(19 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModificationIconSetting);
export default __webpack_public_path__ + "static/media/ModificationIconSetting.6a16a0eca72f905e78fbdf165b10ff1b.svg";
export { ForwardRef as ReactComponent };